import { CreditCardOutlined, PlusOutlined } from '@ant-design/icons';
import { Empty, Tabs, Tooltip, Button, Grid } from 'antd';
import { useState, useEffect } from 'react';

import type { LoyaltyCardsProps } from '@app/components/RecordModal/components/RecordPayment/types';
import {
  AddNewLoyaltyCardModal,
  LoyaltyCardTab,
} from '@app/components/RecordModal/components/RecordPayment/ui';
import { PREFIX } from '@app/constants';

import '@app/components/RecordModal/components/RecordPayment/styles/LoyaltyCards.desktop.scss';

const { useBreakpoint } = Grid;

export const LoyaltyCards: React.FC<LoyaltyCardsProps> = (props) => {
  const {
    loyaltyCards,
    cardBonusesInfo,
    setLoyaltyCards,
    recordId,
    servicesTableData,
    getRecordInfoHandler,
    totalPaid,
    initTable,
    fetchPayments,
    calculateBonusesToEarn,
    setCurrentCard,
  } = props;

  const screens = useBreakpoint();

  const isMobileOrTablet = !screens.lg;

  const [isAddNewLoyaltyCardModalOpen, setIsAddNewLoyaltyCardModalOpen] =
    useState(false);
  const [activeKey, setActiveKey] = useState<string>();

  useEffect(() => {
    if (cardBonusesInfo?.CardId) {
      setActiveKey(cardBonusesInfo.CardId);
    }
    if (loyaltyCards.length && !activeKey) {
      setActiveKey(loyaltyCards[0].id);
    }
  }, [loyaltyCards, activeKey, cardBonusesInfo?.CardId]);

  useEffect(() => {
    if (loyaltyCards.length && activeKey) {
      const selectedCard = loyaltyCards.find((card) => card.id === activeKey);
      setCurrentCard(selectedCard || null);
    }
  }, [activeKey, loyaltyCards, setCurrentCard]);

  if (loyaltyCards.length === 0) {
    return (
      <>
        <Empty
          className="empty-loyalty-cards"
          description={
            <span className={`${PREFIX}loyalty-cards no-data`}>
              Нет доступных карт лояльности
            </span>
          }
        >
          <Button
            type="primary"
            icon={<PlusOutlined />}
            onClick={() => setIsAddNewLoyaltyCardModalOpen(true)}
          >
            Добавить карту
          </Button>
        </Empty>

        <AddNewLoyaltyCardModal
          setLoyaltyCards={setLoyaltyCards}
          open={isAddNewLoyaltyCardModalOpen}
          setIsOpen={setIsAddNewLoyaltyCardModalOpen}
        />
      </>
    );
  }

  const onEdit = (
    _: React.MouseEvent | React.KeyboardEvent | string,
    action: 'add' | 'remove'
  ) => {
    if (action === 'add' && !cardBonusesInfo?.CardId) {
      setIsAddNewLoyaltyCardModalOpen(true);
    }
  };

  const handleTabChange = (key: string) => {
    if (cardBonusesInfo?.CardId) return;
    setActiveKey(key);
  };

  return (
    <div className={`${PREFIX}loyalty-cards`}>
      <Tabs
        type={totalPaid ? 'card' : 'editable-card'}
        tabPosition={isMobileOrTablet ? 'top' : 'left'}
        onEdit={onEdit}
        onChange={handleTabChange}
        activeKey={activeKey}
        moreIcon={null}
        items={loyaltyCards.map((card) => ({
          label: (
            <Tooltip title={card.name}>
              <CreditCardOutlined />
            </Tooltip>
          ),
          key: card.id,
          closable: false,
          children: (
            <LoyaltyCardTab
              card={card}
              cardBonusesInfo={cardBonusesInfo}
              recordId={recordId}
              servicesTableData={servicesTableData}
              getRecordInfoHandler={getRecordInfoHandler}
              totalPaid={totalPaid}
              initTable={initTable}
              fetchPayments={fetchPayments}
              calculateBonusesToEarn={calculateBonusesToEarn}
              activeKey={activeKey}
            />
          ),
        }))}
      />

      <AddNewLoyaltyCardModal
        setLoyaltyCards={setLoyaltyCards}
        open={isAddNewLoyaltyCardModalOpen}
        setIsOpen={setIsAddNewLoyaltyCardModalOpen}
      />
    </div>
  );
};
